import { RootState } from "@app/store"

export const selectCurrentPage = (state: RootState): number => state.pagination.currentPage
export const selectTotalElements = (state: RootState): number => state.pagination.totalElements